module.exports = "query publicCategories {\n  publicCategories {\n    id\n    name\n    status\n    slug\n    is_menu\n    menu_order\n    is_home\n    home_order\n    menu_icon\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/PublicCategories.graphql
// module id = 1867
// module chunks = 1611